// data-testid registry for the CoreX landing page + waitlist form (WAIT-4A).
export const LANDING = {
  page: "landing-page",
  // Hero
  hero: "hero-section",
  heroLogo: "hero-logo",
  heroMedia: "hero-media",
  heroVideo: "hero-video",
  heroHeadline: "hero-headline",
  heroTagline: "hero-tagline",
  // Waitlist
  waitlistSection: "waitlist-section",
  waitlistForm: "waitlist-form",
  inputFirstName: "input-first-name",
  inputLastName: "input-last-name",
  inputEmail: "input-email",
  inputOrganization: "input-organization",
  personaGroup: "persona-group",
  personaOption: (code) => `persona-option-${code}`,
  personaOtherText: "persona-other-text",
  sportGroup: "sport-group",
  sportOption: (code) => `sport-option-${code}`,
  sportOtherText: "sport-other-text",
  consentCheckbox: "consent-checkbox",
  privacyPolicyLink: "privacy-policy-link",
  submitButton: "waitlist-submit-button",
  formStatus: "waitlist-form-status",
  honeypot: "waitlist-honeypot-website",
  errorSummary: "waitlist-error-summary",
  fieldError: (field) => `error-${field}`,
  // Options + submission states
  optionsLoading: "waitlist-options-loading",
  optionsError: "waitlist-options-error",
  optionsRetry: "waitlist-options-retry",
  submitError: "waitlist-submit-error",
  successPanel: "waitlist-success-panel",
  successHeading: "waitlist-success-heading",
  privacyNoticeLink: "waitlist-privacy-notice-link",
  // Mission + footer
  missionSection: "mission-section",
  siteFooter: "site-footer",
};

// Privacy notice page (/privacy)
export const PRIVACY = {
  page: "privacy-page",
  heading: "privacy-heading",
  backLink: "privacy-back-link",
  emailLink: "privacy-email-link",
};
